import React, { useState } from 'react';
import Tooltip from '../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../customHooks/useTranslate';
import greenRabit from '../../../../../images/conejito.svg';
import UnsavedServicesChangesPopUp from './UnsavedServicesChangesPopUp';

interface IconLogoLinkProps {
    isLoading: boolean;
    hasUnsavedChanges: boolean;
    onSave: () => Promise<void>;
    onClick: () => void;
}

const IconLogoLink = ({
    isLoading,
    hasUnsavedChanges,
    onSave,
    onClick,
}: IconLogoLinkProps) => {
    const translate = useTranslate();
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const handleLogoClick = (e: React.MouseEvent<HTMLImageElement>) => {
        if (isLoading) {
            e.preventDefault();
            return;
        }

        if (hasUnsavedChanges) {
            e.preventDefault();
            setIsWarningOpen(true);
        } else {
            onClick();
        }
    };

    return (
        <>
            <Tooltip titleText={translate('back_to_home')}>
                <img
                    src={greenRabit}
                    alt='Zitoneo logo'
                    onClick={handleLogoClick}
                    className='cursor-pointer'
                />
            </Tooltip>
            <UnsavedServicesChangesPopUp
                isOpen={isWarningOpen}
                onClose={() => {
                    setIsWarningOpen(false);
                    onClick();
                }}
                onSave={async () => {
                    await onSave();
                    setIsWarningOpen(false);
                }}
            />
        </>
    );
};

export default IconLogoLink;
